import Routes from './routes/Routes';

import './global.css'

function App() {
  return (
    <div>
      <Routes />
    </div>
  );
}

export default App;
